import React from "react"
import { useDispatch } from "react-redux"

import {
	Box,
	FormControl,
	FormControlLabel,
	Grid,
	InputAdornment,
	Radio,
	RadioGroup,
	TextField,
	Typography,
} from "@mui/material"
import { BiSearch } from "react-icons/bi"

import { masterRecordsSlice, useColumnFilter } from "@/slice/masterRecordsSlice"

export const ColumnSearch = (props: { tableName: string }) => {
	const { tableName } = props

	const dispatch = useDispatch()
	const filterColumns = useColumnFilter(tableName)

	// 前方一致かどうかの判定を保管しておく変数。filterColumns毎に判定を保管する。
	const [forwardMatches, setForwardMatch] = React.useState<{ [columnName: string]: boolean }>({})
	function handleForwardMatchChange(columnName: string, value: boolean) {
		setForwardMatch((prev) => {
			return { ...prev, [columnName]: value }
		})
	}

	// TextFieldの内容を保管しておく変数
	const [texts, setText] = React.useState<{ [columnName: string]: string }>({})
	function handleTextChange(columnName: string, value: string) {
		setText((prev) => {
			return { ...prev, [columnName]: value }
		})
	}

	// TextFieldかforwardMatchesかどうかの判定が変更されたらdispatchする
	React.useEffect(() => {
		dispatch(masterRecordsSlice.actions.resetPagination({ tableName }))
		dispatch(masterRecordsSlice.actions.resetSort({ tableName }))
		for (const columnName of Object.keys(filterColumns)) {
			if (texts[columnName] !== undefined) {
				dispatch(
					masterRecordsSlice.actions.setFilterColumn({
						tableName,
						columnName,
						keyword: texts[columnName],
						isForwardMatch: forwardMatches[columnName] ?? false,
					}),
				)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [texts, forwardMatches, tableName])

	const forms = []
	for (const columnName of Object.keys(filterColumns)) {
		forms.push(
			<Grid container key={`search-${columnName}`} marginTop={1} alignItems="center" maxWidth={900} columnGap={1}>
				<Grid item xs={3} fontSize={14}>
					{columnName}
				</Grid>
				<Grid item xs={4}>
					<TextField
						fullWidth
						type="search"
						variant="standard"
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<BiSearch />
								</InputAdornment>
							),
						}}
						placeholder="検索"
						onChange={(e) => handleTextChange(columnName, e.target.value)}
						autoFocus
					/>
				</Grid>
				<Grid item xs={4}>
					<FormControl>
						<RadioGroup
							row
							aria-labelledby="match-option-group-label"
							defaultValue={false}
							name="forwardMatches"
							onChange={(e) => handleForwardMatchChange(columnName, e.target.value === "true")}
						>
							<Box display="flex" flexDirection="row" justifyContent="space-around">
								<FormControlLabel
									value={false}
									control={<Radio size="small" />}
									label={<Typography fontSize={12}>部分一致</Typography>}
								/>
								<FormControlLabel
									value={true}
									control={<Radio size="small" />}
									label={<Typography fontSize={12}>前方一致</Typography>}
								/>
							</Box>
						</RadioGroup>
					</FormControl>
				</Grid>
			</Grid>,
		)
	}
	return (
		<Grid container spacing={1}>
			{forms}
		</Grid>
	)
}
